/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-09 17:02:33
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-25 14:08:51
 */
const education = [
    {
        path: "/education/detail/:id",
        name: "educationDetail",
        component: () => import("../views/education/detail.vue")
    },
    {
        path: "/article/detail/:type/:id/:relationId?",
        name: "articleDetail",
        component: () => import("../views/education/articleDetail.vue")
    },
    //提醒
    {
        path: "/remind/:id/:type?",
        name: "remind",
        component: () => import("../views/education/remind.vue")
    },
    //表单
    {
        path: "/form/:id/:type?",
        name: "form",
        component: () => import("../views/education/form.vue")
    }
];
export default education;



// WEBPACK FOOTER //
// ./src/router/education.js